import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setMessage } from '@/features/toasts';
import { saveBankAccountInfoService } from '../infra';

export const useSaveBankAccountInfo = ({ userId, userType = 'clouder' }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['system']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['saveBankAccount'],
    mutationFn: ({ payload, isUpdate }) =>
      saveBankAccountInfoService({ userId, userType, payload, isUpdate }),
    onSuccess: async () => {
      dispatch(
        setMessage({
          body: t('BANK_ACCOUNT_SAVED_SUCCESS'),
          type: 'success',
        })
      );
      await queryClient.invalidateQueries({
        queryKey: ['getBankAccount', userId],
      });
    },
    onError: () => {
      dispatch(
        setMessage({
          body: t('BANK_ACCOUNT_UPDATED_ERROR'),
          type: 'error',
        })
      );
    },
  });
};
